import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { CommonAxiosPost } from "../CommonAxios/CommonAxios";
export const successAlert = () => {
    Swal.fire({
        text: "Submitted Successfully",
        icon: "success",
    }).then((refresh) => {

        if (refresh.isConfirmed) {
            window.location.reload(true)
        }
    })
};
 export const successAlertttt = (applicantId, showprintpopup) => {
    Swal.fire({
        title: "Submitted Successfully",
        text: `Your Application Id is ${applicantId}`,
        icon: "success",
        showCancelButton: true,
        confirmButtonText: 'Click here to print application',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        focusConfirm: false,
        footer: '',
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: showprintpopup,
      }).then((response)=>{
        if (response.isConfirmed) {
            console.log("Confirmed");
          }
      })
};


export const successAlert2 = () => {
    Swal.fire({
        text: "Submitted Successfully",
        icon: "success",
    }).then((refresh) => {

        if (refresh.isConfirmed) {
            window.location.reload(true)
        }
    })
};
export const failureAlert = (responseDesc) => {
    Swal.fire({
        text: responseDesc,
        icon: "error",
    })
};

export const deleteAlert = (index, formikFieldArray) => {
    Swal.fire({
        text: "Do you want to delete ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
    }).then((willDelete) => {

        if (willDelete.isConfirmed) {
            formikFieldArray.remove(index);
            //setRowCount(showRowCount - 1);
            // formIk.setFieldValue(`itemMapping[${index}].itemCode`, "");
        }
    })
};
export const deleteAlert2 = (delUrl) => {
    Swal.fire({
        text: "Do you want to delete ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Delete",
    }).then((willDelete) => {

        if (willDelete.isConfirmed) {
            axios.delete(delUrl).then((res) => {
                if (res.data != null) {
                    if (res.data.ResponseCode === "01") {
                        successAlert2("Successfully Deleted");
                    } else {

                        failureAlert(res.data.ResponseDesc);
                    }
                } else {
                    failureAlert(res.data.ResponseDesc);
                }
            })
        }
    })
};
export const saveAlert = (url, data ,msg,callback) => {
    Swal.fire({
        title:"Are you sure ?",
        text: msg,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
    }).then((save) => {
        if (save.isConfirmed) {
            CommonAxiosPost(url,data).then((res) => {
                if (res?.data?.scode === '01') {
                    Sweetalert(res.data.sdesc , 'success')
                    callback();             
                }
                else if (res.data.scode === '02') {
                    Sweetalert(res.data.sdesc, 'warning')
                }
            
            })
        }
    })
}; // not working call back function
export const InfoAlert = (data,icontype) => {
    Swal.fire({
        text: data,
        icon: icontype || "info",
    })
};
export const TokenAlert = () => {
   // let navigate = useNavigate()
    Swal.fire({
        text: "Your session has expired. Please Login",
        icon: "warning",
        backdrop:false,
       // showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"

    }).then((update) => {

         if (update.isConfirmed) {
            window.location.href = "/login";
        }
    })
};

export const alertMessage = () => {
    Swal.fire({
      text: "No Data Found",
      icon: "info",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "OK",
    }).then((willDelete) => {
      if (willDelete.isConfirmed) {
      }
    });
  }
export default async function Sweetalert(text, icon) {
    const isConfirm = await Swal.fire({ text: text, icon: icon, 
      confirmButtonColor: '#3085d6', allowEnterKey: false,
       allowEscapeKey: false, allowOutsideClick: false, confirmButtonText: "Ok" });
    return isConfirm;
  
  }

  export const successAlert5 = () => {
    Swal.fire({
        text: "Updated Successfully",
        icon: "success",
    }).then((refresh) => {

        if (refresh.isConfirmed) {
            window.location.reload(true)
        }
    })
};

